import React from 'react'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import { Social } from '../components/Social'
import Footer from './Footer'
import './all.sass'
import Arrow from '../img/arrow.svg'
import { Location, Router } from '@reach/router'
import { useTransition, animated, config } from 'react-spring'
import AOS from 'aos'


const AnimationWrapper = ({ children }) => <div>{children}</div>

export default class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount(){
    if (AOS.refresh() === undefined) {
      AOS.init()
      console.log("aos initt'd")
    }
  }

  render() {
    const { children } = this.props
    return (
    <StaticQuery
      query={graphql`
        query HeadingQuery {
          site {
            siteMetadata {
              title
              description
            }
          }
        }
      `}
      render={(data) => (
        <div>
          <Helmet>
            <html lang='en' className='' />
            <title>{data.site.siteMetadata.title}</title>
            <meta
              name='description'
              content={data.site.siteMetadata.description}
            />
            {/* tab bar icon */}
            <link
              rel='apple-touch-icon'
              sizes='180x180'
              href='/img/apple-touch-icon.png'
            />
            <link
              rel='icon'
              type='image/png'
              href='/img/ico/pika32.png'
              sizes='32x32'
            />
            <link
              rel='icon'
              type='image/png'
              href='/img/ico/pika16.png'
              sizes='16x16'
            />
            <link rel='mask-icon' href='/img/ico/pika.svg' color='#ff4400' />
            <meta name='theme-color' content='#282828' />
            <script
              async
              src='https://www.googletagmanager.com/gtag/js?id=UA-77762517-3'
            />
            {/* Google Analytics */}
            <script>
              {`
								window.dataLayer = window.dataLayer || [];
								function gtag(){dataLayer.push(arguments);}
								gtag('js', new Date());
								gtag('config', 'UA-77762517-3');
                `}
            </script>
            {/* Animate on scroll stylesheet */}
            <link
              rel='stylesheet'
              href='https://unpkg.com/aos@next/dist/aos.css'
              />

            <meta property='og:type' content='business.business' />
            <meta property='og:title' content={data.site.siteMetadata.title} />
            <meta property='og:url' content='/' />
            <meta property='og:image' content='/static/img/banner.svg' />
          </Helmet>
          {/* <Navbar /> */}
          <a
            className='GithubCorner '
            href='https://github.com/daylennguyen'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='View source on Github'
            >
            <svg
              width='80'
              height='80'
              viewBox='0 0 250 250'
              aria-hidden='true'
              fill='#151513'
              >
              <path d='M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z' />
              <path
                className='octo-arm'
                d='M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2'
                fill='currentColor'
                />
              <path
                className='octo-body'
                d='M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z'
                fill='currentColor'
                />
            </svg>
          </a>
          <Social />
          <div className='main'>
            <Location>
              {(location) => {
                return (
                  <AnimationWrapper location={location}>
                    {children}
                  </AnimationWrapper>
                )
              }}
            </Location>
          </div>
          <Footer />
        </div>
      )}
    />
  )
}}